import styled from 'styled-components'
import { cinnabar100, cinnabar400, green100, green400 } from '../../theme/colors';
import { defaultFont } from '../../theme/typography';

const AlertBox = styled.div`
  width: ${(props) => props.boxWidth || "100%"};
  max-width: ${(props) => props.maxWidth || "551px"};
  background: ${(props) => (props.isFailed ? cinnabar100 : green100)};
  margin-top: ${(props) => props.marginTop || "24px"};
  margin-left: ${(props) => props.marginLeft || "0"};
  border-radius: 8px;
  padding: ${(props) => props.padding || "16px 20px"};
  box-sizing: border-box;
  word-break: break-word;

  p {
    color: ${(props) => (props.isFailed ? cinnabar400 : green400)};
    ${defaultFont};
    margin: 0;
    padding-bottom: ${(props) => (props.isFailed ? "16px" : "0")};
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    word-break: break-word;
  }

  div {
    color: ${(props) => (props.isFailed ? cinnabar400 : green400)};
    a {
      border: 1px solid transparent;
    }
  }

  @media (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 14px 16px !important;
  }
`;

export default AlertBox;
